export enum RecordsType {
    Unfinished = 'unfinished',
    Updated = 'updated',
}
